module.exports = __webpack_public_path__ + "media/images/logo-bleu-d1dec2e29ad2f83485c6dbb0dd13a4d8.png";